import React from 'react';

export type BadgeTone = 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';

interface BadgeProps {
  tone?: BadgeTone;
  dot?: boolean;
  children: React.ReactNode;
  className?: string;
}

const TONE: Record<BadgeTone, string> = {
  primary: 'bg-brand-50 dark:bg-[rgba(203,106,30,0.15)] text-brand-700 dark:text-brand-300 border-brand-200 dark:border-[rgba(203,106,30,0.30)]',
  success: 'bg-success-bg dark:bg-success-dark-bg text-success dark:text-success-dark border-[rgba(30,138,60,0.25)] dark:border-[rgba(30,138,60,0.40)]',
  warning: 'bg-warning-bg dark:bg-warning-dark-bg text-warning dark:text-warning-dark border-[rgba(180,115,10,0.30)] dark:border-[rgba(180,115,10,0.40)]',
  danger:  'bg-danger-bg dark:bg-danger-dark-bg text-danger dark:text-danger-dark border-[rgba(196,50,28,0.25)] dark:border-[rgba(196,50,28,0.40)]',
  info:    'bg-info-bg dark:bg-info-dark-bg text-info dark:text-info-dark border-[rgba(43,95,168,0.25)] dark:border-[rgba(43,95,168,0.40)]',
  neutral: 'bg-surface-alt dark:bg-surface-dark-alt text-ink-subtitle dark:text-ink-subtitle-dark border-line dark:border-line-dark',
};

export function Badge({ tone = 'neutral', dot, children, className = '' }: BadgeProps) {
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium border leading-[1.4]',
        TONE[tone],
        className,
      ].join(' ')}
    >
      {dot && (
        <span className="w-1.5 h-1.5 rounded-full flex-shrink-0 bg-current" />
      )}
      {children}
    </span>
  );
}
